<template>
  <div>
    <h2 class="text-center text-[28px] font-semibold">忘记密码</h2>
    <p class="mt-[4px] text-center text-base">使用邮件重新设置密码</p>
    <Form class="my-6 verify-email-form">
      <FormItem>
        <Input v-model="email" placeholder="请输入注册邮箱" @on-change="error = ''"></Input>
      </FormItem>
      <FormItem>
        <div class="flex items-center justify-between">
          <img :src="captchaURL" alt="图形验证码" @click="onClickRefreshCaptcha">
          <Input v-model="captcha" placeholder="请输入图形验证码"></Input>
        </div>
      </FormItem>
      <FormItem v-if="error" class="min-h-0">
        <Alert type="error" show-icon class="m-0">{{ error }}</Alert>
      </FormItem>
      <FormItem>
        <Button @click="onClickVerify" type="primary" size="large" long class="h-12 rounded-md">提&nbsp;交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { ref, onActivated, onBeforeMount } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { Message } from 'heywhale-ui'
import getErrorMessage from '@/utils/get-error-message'

const router = useRouter()

const email = ref('')
const captcha = ref('')
const error = ref('')

const captchaURL = ref('')

const onClickRefreshCaptcha = () => {
  captchaURL.value = `/captcha?v=${Math.floor(Math.random() * 10000)}_${(new Date()).valueOf()}`;
}

const onClickVerify = async () => {
  try {
    const payload = { email: email.value }
    await axios.post('/api/auth/forget', payload)
    Message.success({ content: '重置邮件已发送，请查收' })
  } catch (e: any) {
    error.value = getErrorMessage(e)
    onClickRefreshCaptcha()
  }
}

onBeforeMount(() => {
  onClickRefreshCaptcha()
})

onActivated(() => {
  onClickRefreshCaptcha()
  captcha.value = ''
  error.value = ''
})
</script>

<style lang="scss">
.verify-email-form {
  .ivu-form-item {
    min-height: 48px;
    margin-bottom: 16px;
  }
  .ivu-input-wrapper {
    input {
      height: 48px !important;
    }
  }
}
</style>
